import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';

function UnsavedChangesModal({
  isOpen,
  onConfirm,
  onCancel,
}: {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <Dialog
      header="Unsaved changes"
      onHide={onCancel}
      footer={
        <>
          <Button label="Leave without Save" onClick={onConfirm} size="small" severity="warning" />
          <Button label="Stay on the page" onClick={onCancel} size="small" />
        </>
      }
      visible={isOpen}
      breakpoints={{ '600px': '100vw' }}
      style={{ width: '600px' }}
      modal
    >
      <Message
        severity="warn"
        text="You are leaving report detail with existing un-saved data. Your un-saved changes will be lost."
      />
    </Dialog>
  );
}

export default UnsavedChangesModal;
